// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Daa-z","narrowOptionButtons":"Eaa-z","noOptions":"Faa-z"};